webpackJsonp([70144966829960],{

/***/ 57:
/***/ (function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fab';
	var iconName = 'github';
	var width = 496;
	var height = 512;
	var ligatures = [];
	var unicode = 'f09b';
	var svgPathData = 'M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faGithub = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fab';
	var iconName = 'medium';
	var width = 448;
	var height = 512;
	var ligatures = [];
	var unicode = 'f23a';
	var svgPathData = 'M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faMedium = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fab';
	var iconName = 'twitter';
	var width = 512;
	var height = 512;
	var ligatures = [];
	var unicode = 'f099';
	var svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faTwitter = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: true });
	var prefix = 'fas';
	var iconName = 'envelope';
	var width = 512;
	var height = 512;
	var ligatures = [];
	var unicode = 'f0e0';
	var svgPathData = 'M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z';
	
	exports.definition = {
	  prefix: prefix,
	  iconName: iconName,
	  icon: [
	    width,
	    height,
	    ligatures,
	    unicode,
	    svgPathData
	  ]};
	
	exports.faEnvelope = exports.definition;
	exports.prefix = prefix;
	exports.iconName = iconName;
	exports.width = width;
	exports.height = height;
	exports.ligatures = ligatures;
	exports.unicode = unicode;
	exports.svgPathData = svgPathData;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'proxima-nova\', futura-pt space;\n  font-size: 30px;\n  display: block;\n  color: rgb(0, 0, 0);\n  text-align: center;\n  vertical-align: baseline;\n  word-wrap: break-word;\n  padding: 30px 0px 0px 0px;\n'], ['\n  font-family: \'proxima-nova\', futura-pt space;\n  font-size: 30px;\n  display: block;\n  color: rgb(0, 0, 0);\n  text-align: center;\n  vertical-align: baseline;\n  word-wrap: break-word;\n  padding: 30px 0px 0px 0px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: \'proxima-nova\', futura-pt space;\n  font-size: 20px;\n  display: block;\n  color: #867e7e;\n  text-align: center;\n  vertical-align: baseline;\n  word-wrap: break-word;\n  padding: 10px 0px 30px 0px;\n'], ['\n  font-family: \'proxima-nova\', futura-pt space;\n  font-size: 20px;\n  display: block;\n  color: #867e7e;\n  text-align: center;\n  vertical-align: baseline;\n  word-wrap: break-word;\n  padding: 10px 0px 30px 0px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: #867e7e;\n\n  &:hover, active {\n    color: black;\n  }\n'], ['\n  color: #867e7e;\n\n  &:hover, active {\n    color: black;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 0px 0px 0px 0px;\n'], ['\n  padding: 0px 0px 0px 0px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: #867e7e;\n\n  &:hover {\n    color: #F5A9A9;\n  }\n'], ['\n  color: #867e7e;\n\n  &:hover {\n    color: #F5A9A9;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactstrap = __webpack_require__(6);
	
	var _reactFontawesome = __webpack_require__(58);
	
	var _freeBrandsSvgIcons = __webpack_require__(86);
	
	var _fontawesomeSvgCore = __webpack_require__(56);
	
	var _faTwitter = __webpack_require__(85);
	
	var _faGithub = __webpack_require__(57);
	
	var _faEnvelope = __webpack_require__(87);
	
	var _faMedium = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TitleText = _styledComponents2.default.p(_templateObject);
	
	var InfoStyle = _styledComponents2.default.p(_templateObject2);
	
	var Anchor = _styledComponents2.default.a(_templateObject3);
	var TalkDiv = _styledComponents2.default.div(_templateObject4);
	var FontIcon = (0, _styledComponents2.default)(_reactFontawesome.FontAwesomeIcon)(_templateObject5);
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    TalkDiv,
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        TitleText,
	        null,
	        'Please, contact me! \uD83D\uDCE8 '
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'd-flex justify-content-around' },
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '12' },
	                _react2.default.createElement(
	                  InfoStyle,
	                  null,
	                  ' Email: rebecca.d.oliveira@gmail.com'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '12' },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: '3' },
	                    _react2.default.createElement(
	                      Anchor,
	                      { href: 'mailto:rebecca.d.oliveira@gmail.com', target: '_blank' },
	                      _react2.default.createElement(FontIcon, { className: 'mx-auto d-inline', icon: _faEnvelope.faEnvelope, size: '2x', color: 'grey' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: '3' },
	                    _react2.default.createElement(
	                      Anchor,
	                      { href: 'https://github.com/rebeccaoliveira', target: '_blank' },
	                      _react2.default.createElement(FontIcon, { className: 'mx-auto d-inline', icon: _faGithub.faGithub, size: '2x', color: 'grey' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: '3' },
	                    _react2.default.createElement(
	                      Anchor,
	                      { href: 'https://twitter.com/rebyoliveira', target: '_blank' },
	                      _react2.default.createElement(FontIcon, { className: 'mx-auto d-inline', icon: _faTwitter.faTwitter, size: '2x', color: 'grey' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: '3' },
	                    _react2.default.createElement(
	                      Anchor,
	                      { href: 'https://medium.com/@RebyOliveira', target: '_blank' },
	                      _react2.default.createElement(FontIcon, { className: 'mx-auto d-inline', icon: _faMedium.faMedium, size: '2x', color: 'grey' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('hr', null)
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(52);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(6);
	
	var _logoReactHeartBlue = __webpack_require__(74);
	
	var _logoReactHeartBlue2 = _interopRequireDefault(_logoReactHeartBlue);
	
	var _ContactPage = __webpack_require__(256);
	
	var _ContactPage2 = _interopRequireDefault(_ContactPage);
	
	var _HeaderHome = __webpack_require__(61);
	
	var _HeaderHome2 = _interopRequireDefault(_HeaderHome);
	
	var _Footer = __webpack_require__(60);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Rebecca Oliveira - Contact',
	        meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	      }),
	      _react2.default.createElement(_HeaderHome2.default, null),
	      _react2.default.createElement(_ContactPage2.default, null),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-291da321af5214acfdd0.js